var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2135_40939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8243 1.7695C11.59 1.53517 11.2101 1.53517 10.9757 1.7695L3.78737 8.95794L1.02428 6.19485C0.789973 5.96052 0.410098 5.96054 0.175746 6.19485C-0.058582 6.42915 -0.058582 6.80903 0.175746 7.04335L3.36311 10.2307C3.59734 10.465 3.9775 10.4648 4.21164 10.2307L11.8243 2.61803C12.0586 2.38372 12.0586 2.00382 11.8243 1.7695Z",
    fill: "#00A094"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2135_40939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.cf429523f491d70f6bae12d238ced309.svg";
export { ForwardRef as ReactComponent };